import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import LinearProgress from "@mui/material/LinearProgress";
const LinearProgressBar = ({
  classes,
  variant = "determinate",
  theme
}) => {
  const [progress, setProgress] = React.useState(10);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => prevProgress >= 100 ? 10 : prevProgress + 10);
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/React.createElement(LinearProgress, {
    sx: {
      height: "3px"
    },
    classes: classes,
    variant: variant,
    value: progress
  });
};
const styles = {};
export default withStyles(styles)(LinearProgressBar);
LinearProgressBar.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object.isRequired,
  variant: PropTypes.string
};